import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { mawbEndpoint, linkingEndpoint } from 'src/app/utils/constants/requestUrl';

@Injectable({
  providedIn: 'root',
})
export class MawbService {
  constructor(private http: HttpClient) {}

  createMawb(data): Observable<any> {
    return this.http.post(`${environment.mawbUrl}${mawbEndpoint.createMawb}`, data);
  }

  getMawbList(data): Observable<any> {
    return this.http.post(`${environment.mawbUrl}${mawbEndpoint.getMawbList}`, data);
  }

  closeMother(data) {
    return this.http.post(`${environment.mawbUrl}${mawbEndpoint.closeMawb}`, data);
  }

  deleteMother(data) {
    let params = new HttpParams();
    params = params.append('mawb', data.mawb);
    return this.http.get(`${environment.mawbUrl}${mawbEndpoint.deleteMawb}`, { params });
  }

  getPalletList(data): Observable<any> {
    return this.http.post(`${environment.mawbUrl}${mawbEndpoint.getMawbList}`, data);
  }

  linkPieces(data) {
    return this.http.post(`${environment.linking}${linkingEndpoint.linkPieces}`, data);
  }

  unlinkPieces(data) {
    return this.http.post(`${environment.linking}${linkingEndpoint.deLinkPieces}`, data);
  }

  managePallet(data): Observable<any> {
    return this.http.post(`${environment.linking}${linkingEndpoint.managePallet}`, data);
  }

  getMawbUploadList(requestBody) {
    return this.http.post(`${environment.mawbUrl}${mawbEndpoint.viewMawbFileData}`, requestBody);
  }

  deleteUploadCI(requestBody) {
    return this.http.delete(`${environment.mawbUrl}${mawbEndpoint.deleteUploadedCI}`, requestBody);
  }

  lbbxMotherLink(data) {
    return this.http.post(`${environment.mawbUrl}${mawbEndpoint.lbbxShipmentLink}`, data);
  }

  dgContentValues(requestBody) {
    return this.http.post(`${environment.mawbUrl}${mawbEndpoint.saveDGContent}`, requestBody);
  }

  saveInvoiceUploadData(requestBody) {
    return this.http.post(`${environment.mawbUrl}${mawbEndpoint.saveInvoice}`, requestBody);
  }
 
  updatemawbCharges(mawb, requestBody) {
    return this.http.put(
      `${environment.mawbUrl}${mawbEndpoint.updatemawbCharges}/${mawb}`,
      requestBody
    );
  }

  updatemawbInvoiceRerence(mawb, requestBody) {
    return this.http.put(
      `${environment.mawbUrl}${mawbEndpoint.updatemawbInvoiceReference}/${mawb}`,
      requestBody
    );
  }
  updatemawbreference(mawb, requestBody) {
    return this.http.put(
      `${environment.mawbUrl}${mawbEndpoint.updatemawbreference}/${mawb}`,
      requestBody
    );
  }
}
